import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { Remove, Add } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core'
import Checkbox from '../checkbox'
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
    useMediaQuery
} from '@material-ui/core';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import colors from '../CustomizedUIs/Colors'
import { useTranslate } from 'react-admin';
import ExpandButton from '../CustomizedUIs/ExpandButton';
const useStyles = makeStyles(theme => ({
    tableCell: {
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    Checkbox: {
        color: "white",
    },
    IconBorderOpen: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: ' #ffffff',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    },
    IconBorder: {
        width: '30px',
        height: '30px',
        borderRadius: '10px',
        backgroundColor: '#e5f1f8',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }, TextGroupOpen: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#fafefe',
        paddingLeft: 10
    },
    TextGroup: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
        paddingLeft: 10
    },
    TextTitle: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextTitleOpen: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    border: {
        borderRadius: '10px',
        boxShadow: '0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: ' #ffffff',
    },
    borderOpen: {
        width: '700px',
        borderRadius: '10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: theme.palette.primary.main,
    }

}));

export default function SubItem({ children, groupData, countCluster, onToggleExpand, onChange }) {
    const translate = useTranslate();
    const classes = useStyles();
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const theme = useTheme()
    var statuscreate = 0
    var filterArrayCreate = groupData.functions.filter(value => value.isCreate)
    if (filterArrayCreate.length === groupData.functions.length)
        statuscreate = 1
    else if (filterArrayCreate.length === 0)
        statuscreate = 0
    else
        statuscreate = 2
    var statusedit = 0
    var filterArrayRead = groupData.functions.filter(value => value.isRead)
    if (filterArrayRead.length === groupData.functions.length)
        statusedit = 1
    else if (filterArrayRead.length === 0)
        statusedit = 0
    else
        statusedit = 2
    const { expand, name } = groupData;
    const changeSelected = (e, type) => {
        e.stopPropagation();
        onChange(type)
    }

    return (
        <Box borderRadius='10px' className={expand ? classes.borderOpen : classes.border}>
            <Box style={{ cursor: 'pointer' }} display='flex' width='100%'>
                <Box width='10px' bgcolor={expand ? '#ffffff' : theme.palette.secondary.main} style={{ opacity: expand ? 0.2 : 1, borderTopLeftRadius: '10px', borderBottomLeftRadius: expand ? 0 : '10px' }}></Box>
                <ListItem onClick={() => onToggleExpand(groupData)}>
                    <ListItemText primary={<Typography className={expand ? classes.TextGroupOpen : classes.TextGroup}>{name}</Typography>} />
                    <Box display="flex" style={{ alignItems: "center", color: !expand ? theme.palette.text.primary : 'white' }} width='79px' mr={isDesktop ? 10 : 1}  >
                        <Typography className={expand ? classes.TextTitleOpen : classes.TextTitle} >{translate(`resources.role.edit`)}</Typography>
                        <Box>
                            {expand ? <Checkbox indeterminate={statuscreate === 2} checked={statuscreate === 1} onClick={(e) => changeSelected(e, 'EDIT')} checkedColor='white' checkIconColor={theme.palette.primary.main} iconColor={null} borderColor='white'>
                            </Checkbox> : <Checkbox indeterminate={statuscreate === 2} checked={statuscreate === 1} onClick={(e) => changeSelected(e, 'EDIT')} style={{ color: statuscreate === 0 ? '#b4b5bd' : theme.palette.primary.main }} ></Checkbox>}
                        </Box>
                    </Box>
                    <Box display="flex" style={{ alignItems: "center", color: !expand ? theme.palette.text.primary : 'white' }} width='79px' textAlign='center' py={1} mr={isDesktop ? 10 : 1} >
                        <Typography className={expand ? classes.TextTitleOpen : classes.TextTitle} >{translate(`resources.role.read`)}</Typography>
                        <Box>
                            {expand ? <Checkbox indeterminate={statusedit === 2} checked={statusedit === 1} onClick={(e) => changeSelected(e, 'READ')}
                                checkedColor='white' checkIconColor={theme.palette.primary.main} iconColor={null} borderColor='white' disabled={statuscreate === 1 ? true : false}></Checkbox> :
                                <Checkbox disabled={statuscreate === 1 ? true : false} indeterminate={statusedit === 2} checked={statusedit === 1} onClick={(e) => changeSelected(e, 'READ')}
                                    style={{ color: statuscreate === 1 ? '#88898c' : statusedit === 0 ? '#b4b5bd' : theme.palette.primary.main }} ></Checkbox>}
                        </Box>
                    </Box>
                   <ExpandButton open={expand}/>
                </ListItem>
            </Box>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <Box display='flex'>
                    <Box className={classes.tableCell} width='4px' bgcolor={theme.palette.secondary.main}></Box>
                    <Box bgcolor='background.paper' width='100%'>
                        <List component="div" disablePadding>
                            {children}
                        </List>
                    </Box>
                </Box>
            </Collapse>

        </Box>
    );
}
